/*Recurso: Notifications - Servicio de lectura del API: Maneja las notificaciones al usuarios presentandas en el encabezado
  Tareas:
    GetSummarybyUser   //Lista de Notificaciones (pendientes y avisos)      
    SendEmail          //...
    DeleteNoticebyUser //Elimina los avisos 
*/
//elementos stores: elementos que llenamos con inf. del api y otros elementos captados del front o para manejo del front
//funciones stores: rutinas que captan o modifican los elementos store
//response: { config: {}, hearders:{}, request:{}, data: { informacion: {}, resultado: {}, contenido: [{ }] } } //esto trae la lectura de api

import create from "zustand";

const notificationsStore = create((set:any, get:any) => ({

  objErrorNotificationsStore: { hasError: false, url: '', body:'', recurso:"notifications", componente:'', idresul: 0, desresul:'', menu:''}, //se llena con la información del api si éste tiene error

      //*Limpia objeto de error cuando éste ya se mostro en VentanaObjeErrorAPI
      limpiaObjErrorNotificationsStore: () => {
          //alert('notifications.store - limpiaObjErrorNotificationsStore:');
          let paso = { hasError: false, url:'', body:'', recurso:'notifications', componente:'', idresul:0, desresul:'', menu:''}
          set( { objErrorNotificationsStore: paso } );
          //console.log('notificationsStore - limpiaobjErrorNotificationsStore (sale) - objErrorNotificationsStore: ', get().objErrorNotificationsStore);
      },
        
      //*Error en api: entra a esta función cuando el servicio cae en catch y muestra el error en VentanaObjError
      generaObjErrorNotificationsStore: async (responseAPI:any, h:any, h2:any, e:any, c:any, m:any) => {
          //alert('notificationsStore - generaobjErrorNotificationsStore:');
          //console.log('****generaobjErrorNotificationsStore (entra): ', responseAPI);
          //console.log('*generaobjErrorNotificationsStore (entra): h: ', h , ' h2: ',  h2 , ' e: ', e , ' c: ', c );
          let paso = { hasError: h, url:'', body:e, recurso:'notifications', componente:c, idresul:0, desresul:'', menu:m }
          if (responseAPI==undefined  || responseAPI=='Error: Network Error'){
            paso.idresul=-1;
            paso.desresul= 'Error inesperado, asegure su conexión con internet y vpn';
          }
          else if (responseAPI=='Error detectado por api en ret') {
            paso.desresul= h;
            paso.idresul= h2; 
          }
          else {
            let temp = responseAPI.config;
            paso.url = temp.url;
            if (responseAPI.data!="" && responseAPI.data!=null){
              paso.idresul=responseAPI.data.ret;
              paso.desresul= responseAPI.data.msjerror;
            }    
            else {
                paso.idresul= responseAPI.status;
                if (responseAPI.status==404)
                    paso.desresul= "El usuario no existe"//responseAPI.statusText;  
                else
                    paso.desresul= responseAPI.statusText;  
            }    
          }
          set( { objErrorNotificationsStore: paso } );
          console.log('notificationsStore - generaObjError (sale) - objError: ', get().objErrorNotificationsStore);
      },

  notificacionesStore: {},  //guarda las notiticaciones del usuario (response.data)
  notAvisosStore: [],  // guarda las notificaciones de Avisos
  notPendientesStore: [],  //guarda las notificaciones de Pendientes
  notTotalStore:0, //guarda el total de pendientes y avisos, lo ocupamos para el encabezado a un lado de la campana
  notTotalAvisosStore:0, //guarda el total de  avisos, lo ocupamos para la ventana de notificaciones
  notTotalPendienteStore:0, //guarda el total de pendientes , lo ocupamos para la ventana de notificaciones    

      //*Tarea: GetSummarybyUser, // se ejecuta al entrar paginaSSC quien llama al Encabezado - opción (Campana)-Notificaciones en un useEffect, 
      // carga las notificaciones (avisos y pendientes) existentes dentro elementos store + lo que ocupa el front
      guardaGetSummarybyUserStore: async (responseAPI:any) => {  
        //alert('notifications.store - guardaGetSummarybyUserStore' );
        if (responseAPI.ret==1) { //sin error
          //console.log('guardaGetSummarybyUserStore - responseAPI:', responseAPI)
          set( { notificacionesStore: responseAPI.item } );

          set( { notAvisosStore: responseAPI.item.ads } );
          set( { notTotalAvisosStore:  responseAPI.item.ads.length})
          
          set( { notPendientesStore:  get().notificacionesStore.pending } );
          set( { notTotalPendienteStore:  responseAPI.item.pending.length});
          
          set( { notTotalStore: responseAPI.item.ads.length + responseAPI.item.pending.length});

          //let descripcion = '';
          let pos = 0;
          get().notAvisosStore.map((na:any, index:any) => {
            na.activo = false; //por omisión entra cerrado
            pos = na.notice.indexOf(':');
            na.descripcion = na.notice.substr( 0, pos);
          });
          get().notPendientesStore.map((np:any, index:any) => {
            pos = np.notice.indexOf(':');
            np.descripcion = np.notice.substr( 0, pos);
          });
          //console.log ('notificacionesStore: ', get().notificacionesStore );
          //console.log ('notAvisosStore: ', get().notAvisosStore );
          //console.log ('notPendientesStore: ', get().notPendientesStore );
          return(get().notificacionesStore);
      }
      else {
        get().generaObjErrorNotificationsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'notitications.store-guardaGetSummarybyUserStore ')
      }
      },
      
      // se ejecuta al entrar dentro del Encabezado en un useEffect, 
      // se usa este dato para mostrar el valor de notificaciones a un lado de la campana
      guardaTotalNotificacionesStore: async (responseAPI:any) => {  // Tareas: GetSummarybyUserStore
        //console.log('guardaTotalNotificacionesStore - responseAPI:', responseAPI)
        set( { notTotalStore: responseAPI.item } );
        //console.log ('notTotalStore: ', get().notTotalStore );
      },

  deleteNoticebyUsertore:{},   

      //*Tarea: DeleteNoticebyUser, elimina los avisos
      guardaDeleteNoticebyUserStore: async (responseAPI:any) => {  
        if (responseAPI.ret==1) { //sin error
            set( { deleteNoticebyUsertore: responseAPI } ); 
            //console.log('deleteNoticebyUsertore', get().deleteNoticebyUsertore)
            return(get().deleteNoticebyUsertore);   
        }
        else {
          get().generaObjErrorNotificationsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'notitications.store-guardaDeleteNoticebyUserStore ')
        }
      },

      //se ejectura dentro de la ventana de Notificaciones al dar click en aviso para activar y desactivar
      //el elemento activo se generó a cada elemento de aviso dentro de guardaGetSummarybyUserStore
      activaDesactivaNotAvisosStore: async (id:any) => {  
        //console.log('activaDesactivaNotAvisosStore - id:', id)
        get().notAvisosStore.map((na:any) => {
          if (na.idnews==id)
              na.activo = !na.activo;
        });
        //console.log ('-id: ', id,  '  -notAvisosStore: ', get().notAvisosStore );
      },
  
      //se ejectura dentro de la ventana de Notificaciones al dar click en aviso para activar y desactivar
      //el elemento activo se generó a cada elemento de aviso dentro de guardaGetSummarybyUserStore
      activaDesactivaTodosNotAvisosStore: async (opcion:any) => {  
        get().notAvisosStore.map((na:any) => {
          na.activo = !opcion;
        });
        //console.log ('notAvisosStore: ', get().notAvisosStore );
      },

  sendEmailStore:{}, 
    
      //*Tarea: SendEmail
      guardaSendEmailStore: async (responseAPI:any) => {  
        if (responseAPI.ret==1) { //sin error
          set( { sendEmailStore: responseAPI } ); 
          //console.log('sendEmailStore:', get().sendEmailStore)
          return(get().sendEmailStore);      
        }
        else {
          get().generaObjErrorNotificationsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'notitications.store-guardaSendEmailStore ')
        }
      },
    
}));

export default notificationsStore;
